export default function shouldShowChart(prop) {
  return !!(prop?.table
    && Object.keys(prop?.table?.headers).length
    && Object.keys(prop?.table?.rows).length);
}
